export default __webpack_public_path__ + "assets/security-and-compliance-overview.86ebefabaf79cb8fd1bdd255b9f885b8.pdf";